var TEMPLATE_URL = require('./footer.nav.html');

angular.module('ikeweb.layout').directive('footerNav', function() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: TEMPLATE_URL,
        link: function($scope) {
            $scope.applicationVersion = require('../../../config').package.version;
            $scope.copyrightDate = 2026;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/footer/footer.nav.directive.js
// module id = 463
// module chunks = 0